
export const DRONE_RC_ITEMS = ['LocoDroneT', 'LocoDroneTT'];